/* import __COLOCATED_TEMPLATE__ from './inbox-name-with-logo.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();